import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { EditRoleLink } from '../../../links/index.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';

const PermissionsTableRow = ({
  slug,
  id,
  name,
  roles,
  groups,
  userId,
  currentUserId,
}) => {
  const [showProjectRoles, setShowProjectRoles] = useState(false);
  const [showGroups, setShowGroups] = useState(false);

  const renderProjectRoles = (length) => {
    return (
      <div className="flex flex-col flex-align-start">
        <div
          className={`flex flex-wrap roles ${!showProjectRoles ? 'show-less' : ''}`}
        >
          {roles.map((role, index) => (
            <span key={index} className="label role-item">
              {role}
            </span>
          ))}
        </div>
        {length > 2 ? (
          <button
            type="button"
            className={`btn-link m-t-4 ${showProjectRoles ? 'arrow-up' : 'arrow-down'}`}
            onClick={() => setShowProjectRoles(!showProjectRoles)}
          >
            <strong>{showProjectRoles ? 'Show Less' : 'Show More'}</strong>
          </button>
        ) : null}
      </div>
    );
  };

  const renderGroups = (length) => {
    return (
      <div className="flex flex-col flex-align-start">
        <div
          className={`flex flex-col flex-align-start groups ${!showGroups ? 'show-less' : ''}`}
        >
          {groups.map((group, index) => (
            <div key={index} className="flex group-item">
              <div className="flex">
                <strong className="group-name">{group.name}</strong>
              </div>
              {group.roles.map((role, index) => (
                <div key={index}>
                  <span className="label group-role-item">{role}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
        {length > 2 ? (
          <button
            type="button"
            className={`btn-link m-t-4 ${showGroups ? 'arrow-up' : 'arrow-down'}`}
            onClick={() => setShowGroups(!showGroups)}
          >
            <strong>{showGroups ? 'Show Less' : 'Show More'}</strong>
          </button>
        ) : null}
      </div>
    );
  };

  return (
    <tr>
      <td>
        <strong>
          <h4>{name}</h4>
        </strong>
      </td>
      <td className="project-roles">
        {roles.length ? renderProjectRoles(roles.length) : '—'}
      </td>
      <td>{groups.length ? renderGroups(groups.length) : '—'}</td>
      {userId !== currentUserId ? (
        <AuthorizedAction action="update" subject="userProjectRole">
          <td style={{ width: '100px' }}>
            <EditRoleLink userId={userId} projectId={id}>
              <Button bsStyle="default" className="btn-edit">
                Edit
              </Button>
            </EditRoleLink>
          </td>
        </AuthorizedAction>
      ) : null}
    </tr>
  );
};

export default PermissionsTableRow;
